import { FC } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Typography, Theme, Box } from '@material-ui/core'
import { localStorage } from 'react-storage'
import { FormattedMessage } from 'react-intl'
import { Linq } from '@src/components/Linq'
import { sendCommonDetailProductIdEvent } from '@src/utils/analytics'
import { documentTypeMapper } from './certificateUtils'

type DocumentationLookupProps = {
  documentType: string
  productNumber: string
}

export const useStyles = makeStyles((theme: Theme) => ({
  searchLink: {
    marginTop: theme.spacing(4),
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
    margin: theme.spacing(3, 0),
  },
}))

export const DocumentationLookup: FC<DocumentationLookupProps> = ({
  documentType,
  productNumber,
}) => {
  const classes = useStyles()
  const docType = documentTypeMapper[documentType].abbrev

  return (
    <Box data-testid="documentation-lookup">
      <Typography className={classes.title} variant="body1">
        <FormattedMessage
          id="DONT_SEE_RIGHT_VERSION"
          defaultMessage="Don't see the Right Version?"
        />
      </Typography>
      <Typography variant="body2">
        <FormattedMessage
          id="DOCUMENTATION_LOOKUP_DESCRIPTION"
          defaultMessage="If you require a particular version, you can look up a specific certificate by the Lot or Batch number."
        />
      </Typography>
      <Box className={classes.searchLink}>
        <Linq
          href={`/documents-search?tab=${docType.toLowerCase()}`}
          onClick={() => {
            sendCommonDetailProductIdEvent({
              event: 'documentation_interaction',
              action: `visit ${docType.toLowerCase()} search`,
              detail: `${docType.toLowerCase()} tab`,
              section: 'document search',
              component: 'left rail',
              elementType: 'link',
              elementText: `search for a ${docType.toLowerCase()}`,
              linkUrl: `/documents-search?tab=${docType.toLowerCase()}`,
              coreEvent: 'no',
              productId: productNumber,
            })
            localStorage.setItem('pdpProductNumber', productNumber)
          }}
        >
          <FormattedMessage
            id="DOCUMENTATION_LOOKUP_SEARCH_FOR"
            defaultMessage={'Search for a {docType}'}
            values={{ docType }}
          />
        </Linq>
      </Box>
    </Box>
  )
}

export default DocumentationLookup
